module.exports = ".document-url{display:flex;align-items:center}.mat-card{padding-left:0;padding-right:0}\n"